import { Component, forwardRef } from 'react';
import { createPropsGetter } from '@optimus-web/common';
import { DialogBaseProps, Dialog as DialogElement } from '../Dialog';
import { MenuInnerList as MenuListComponent } from '../MenuInnerList';
import { FooterProps, OpenableOverlay } from '../OpenableOverlay';
import { MenuProps } from './MenuProps';

const CustomDialog = (props: DialogBaseProps) => {
    const dialogProps = {
        actions: [{ children: 'Cancel', onClick: props.onClose, type: 'submit' as const }],
    };

    return <DialogElement {...dialogProps} {...props} />;
};

type DefaultProps = typeof defaultProps;
const defaultProps = {
    focusListOnOpen: true,
};

const getProps = createPropsGetter(defaultProps);

type OwnProps = MenuProps &
    React.HTMLAttributes<HTMLDivElement> & {
        footerProps?: FooterProps;
    };

type Props = OwnProps & Partial<DefaultProps>;

/**
 * @deprecated
 */
export class MenuComponent extends Component<Props> {
    static readonly defaultProps = defaultProps;

    render() {
        const {
            anchorElement,
            children,
            opened,
            scrollable,
            sizeToAnchor,
            showAsDialog,
            onClose,
            portalContainerId,
            forwardedRef,
            overlayMinWidth,
            placement = 'bottom-start' as const,
            footerProps,
            ...other
        } = getProps(this.props);

        const overlayProps = {
            portalContainerId,
            anchorElement,
            opened,
            sizeToAnchor,
            scrollable,
            innerRef: forwardedRef,
            minWidth: overlayMinWidth,
            placement,
            footerProps,
        };

        const listProps = {
            ...other,
            tabIndex: -1,
            fullWidth: showAsDialog,
        };

        const dialogProps = {
            active: opened,
            onBackdropClick: onClose,
            contentWithoutPadding: true,
            portalContainerId,
            ref: forwardedRef,
        };

        return showAsDialog ? (
            <CustomDialog {...dialogProps}>
                <MenuListComponent {...listProps}>{children}</MenuListComponent>
            </CustomDialog>
        ) : (
            <OpenableOverlay {...overlayProps}>
                <MenuListComponent {...listProps}>{children}</MenuListComponent>
            </OpenableOverlay>
        );
    }
}

export const Menu = forwardRef<HTMLDivElement, Props>((props, ref) => <MenuComponent {...props} forwardedRef={ref} />);
